import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
} from "@ey-xd/motif-react";
import Button from "../Button/Button";
import "./DiscardModal.scss";
import { resetEstimateChangeState } from "../../store/slices/CheckoutSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { getUserLogout } from "../../store/slices/UserLogoutSlice";
import { useAppDispatch } from "../../store/hooks";

type Props = {
  isVisible: boolean;
  setIsVisible?: (isVisible: boolean) => void;
  isChangedActive?: boolean;
};

export default function DiscardModal({ isVisible, setIsVisible, isChangedActive }: Props) {
  const dispatch = useAppDispatch();
  const isLogout = useSelector(
    (state: RootState) => state.CheckoutSlice.isLogout,
  ) || false;
  const nav = useNavigate();
  useEffect(() => {
    if (!isChangedActive) {
      setIsVisible && setIsVisible(false);
    }
  }, [isChangedActive, isVisible, setIsVisible]);

  return (
    <>
      <MotifModal
        className="discardModal"
        onClose={() => setIsVisible && setIsVisible(false)}
        show={isVisible && isChangedActive}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="discardModalWrapper">
          <MotifModalHeader
            closeButtonProps={{
              'aria-label': 'Custom Close Button aria-label',
              title: 'Custom Close Button title'
            }}
            style={{
              borderWidth: '',
              paddingBottom: ''
            }}
          >
            <span
              className="header-message"
            >
              Discard Changes?
            </span>
          </MotifModalHeader>
          <MotifModalBody>
            <div className="discard_message">
              If you leave now, your changes will be lost.
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={"cancel"}
              variant={"secondary"}
              className="delBtn hide"
              onClickHandler={() => {
                setIsVisible && setIsVisible(false);
              }}
            />
            <Button
              label={"Keep working"}
              variant={"primary"}
              className="delBtn"
              onClickHandler={() => {
                setIsVisible && setIsVisible(false);
                sessionStorage.setItem('redirectTo', window.location.pathname + window.location.search);
                document.getElementsByTagName("body")[0].style.overflow = "";
              }}
            />
            <Button
              label={"Discard changes"}
              variant={"secondary"}
              className="cancelBtnModal"
              onClickHandler={async () => {
                setIsVisible && setIsVisible(false);
                dispatch(resetEstimateChangeState());
                isLogout ? dispatch(getUserLogout()) : nav(sessionStorage.getItem('redirectTo') || "/");
              }}
            />
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}